import { useState, useEffect } from 'react'

import { useSelector } from 'react-redux'
import MakeModelFilter from './SearchFilters/MakeModelFilter'
import SelectFilter from './SearchFilters/SelectFilter'
import FromToFilter from './SearchFilters/FromToFilter'
import CheckboxFilter from './SearchFilters/CheckboxFilter'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import CountryFilter from './SearchFilters/CountryFilter'

const SearchFilters = (props) => {
  const [showFilters, setShowFilters] = useState(false)
  const screenWidth = useWindowDimensions()?.width
  const [countries, setCountries] = useState(undefined)
  const [makes, setMakes] = useState(undefined)
  const [categories, setCategories] = useState(undefined)
  const [registrationCountries, setRegistrationCountries] = useState(undefined)
  const [showMoreFilters, setShowMoreFilters] = useState(false)

  const currency = useSelector((state) => state.items.currency)
  const currentMileage = useSelector((state) => state.items.currentMileage)

  const toggleMoreFilters = () => {
    setShowMoreFilters(!showMoreFilters)
  }

  const loadMakes = () => {
    props.makes().then((response) => {
      setMakes(response.data)
    })
  }

  const loadCountries = () => {
    props.countries().then((response) => {
      setCountries(response.data)
    })
  }

  const loadRegistrationCountries = () => {
    props.registrationCountries().then((response) => {
      setRegistrationCountries(response.data)
    })
  }

  const loadCategories = () => {
    props.categories().then((response) => {
      setCategories(response.data)
    })
  }

  useEffect(() => {
    loadMakes()
    loadCountries()
    loadCategories()
    loadRegistrationCountries()
  }, [])

  return (
    <div className="filter-container mt-5">
      {screenWidth < 768 && (
        <div className="filter-toggle-wrapper mb-2">
          <button
            className="btn btn-white w-100"
            type="button"
            onClick={() => setShowFilters(!showFilters)}
          >
            <i className="fas fa-sliders-h fa-fw" />{' '}
            {showFilters ? I18n.t('hide_filters') : I18n.t('show_filters')}
          </button>
        </div>
      )}
      {(showFilters || screenWidth >= 768) && (
        <div className="rounded mb-3 px-0">
          <div className="row g-0 align-items-stretch">
            <div className="col col-md me-1">
              <MakeModelFilter makes={makes} />

              <CheckboxFilter
                title={I18n.t('search.filters.condition.title')}
                name="condition"
                options={App.State.conditions}
              />

              <FromToFilter
                name="year"
                title={I18n.t('search.filters.year.title')}
                validation={{
                  from: 1880,
                  to: new Date().getFullYear() + 1,
                }}
              />

              {showMoreFilters && (
                <CheckboxFilter
                  title={I18n.t('search.filters.fuel_type.title')}
                  name="fuel_type"
                  options={App.State.fuelTypes}
                />
              )}
            </div>
            <div className="col col-md me-1">
              <CountryFilter countries={countries} />

              <CheckboxFilter
                title={I18n.t('search.filters.body_type.title')}
                name="body_type"
                options={App.State.bodyTypes}
              />

              <FromToFilter
                name="mileage"
                title={I18n.t('search.filters.mileage.title')}
                inputSuffix={currentMileage}
                validation={{
                  from: 1,
                  to: 999999,
                }}
              />

              {showMoreFilters && (
                <CheckboxFilter
                  title={I18n.t('search.filters.drive_wheels.title')}
                  name="drive_wheels"
                  options={App.State.driveWheels}
                />
              )}
            </div>
            <div className="col col-md d-none d-md-block me-1">
              <FromToFilter
                name="price"
                title={I18n.t('search.filters.price.title')}
                inputSuffix={currency}
                validation={{
                  from: 1,
                  to: 10 ** 7,
                }}
              />
              <SelectFilter
                title={I18n.t('search.filters.categories.title')}
                name="category_id"
                type="array"
                options={categories}
              />

              <SelectFilter
                title={I18n.t('search.filters.color.title')}
                name="color"
                type="array"
                options={App.State.colors}
              />
              {showMoreFilters && (
                <SelectFilter
                  title={I18n.t(
                    'search.filters.first_registration_country.title'
                  )}
                  name="first_registration_country"
                  type="array"
                  options={registrationCountries}
                />
              )}

            </div>
            <div className="col col-md d-none d-md-block">
              <FromToFilter
                name="power"
                title={I18n.t('search.filters.power.title')}
                inputSuffix="kw"
                validation={{
                  from: 1,
                  to: 9999,
                }}
              />

              <CheckboxFilter
                title={I18n.t('search.filters.gearbox.title')}
                name="gearbox"
                options={App.State.gearboxTypes}
              />

              <CheckboxFilter
                title={I18n.t('search.filters.features.title')}
                name="features"
                options={App.State.otherFeatures}
              />

              {showMoreFilters && (
                <CheckboxFilter
                  title={I18n.t('search.filters.steering_wheel.title')}
                  name="steering_wheel"
                  options={App.State.steeringWheelTypes}
                />
              )}
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2">
            <button
              className="btn btn-sm text-primary"
              onClick={toggleMoreFilters}
            >
              {showMoreFilters ? (
                <>
                  {I18n.t('search.filters.hide')}
                  <i className="fa-solid fa-chevron-up ms-2" />
                </>
              ) : (
                <>
                  {I18n.t('search.filters.show')}
                  <i className="fa-solid fa-chevron-down ms-2" />
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchFilters
